// extracted by mini-css-extract-plugin
module.exports = {"price":"index-module__price___yMPR7","strikethroughPrice":"index-module__strikethroughPrice___34ttm"};